import { RouteRecordRaw } from 'vue-router'

const Users = () =>
  import(/* webpackChunkName: "users-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'usuarios',
    name: 'users',
    component: Users,
    meta: {
      title: 'Usuarios',
      auth: {
        requiredPermission: 'users.view',
        requiredModule: 'users',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
